"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HTML = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _helpers = require("../../helpers");

var _space = require("../../helpers/space");

var _Text = require("../Text");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var htmlMixin = (0, _styledComponents.css)(["> h1,> h2,> h3,> h4,> h5,> ul,> ol,> p,> blockquote,> pre,> hr{margin:", "px auto;&:first-child{margin-top:0;}&:last-child{margin-bottom:0;}}> hr{height:1px;border:0;background-color:", ";}"], (0, _space.space)(1), (0, _helpers.color)("black10"));
var Container = (0, _styledComponents.default)(_Text.Text).withConfig({
  displayName: "HTML__Container",
  componentId: "sc-1im40xc-0"
})(["", ""], htmlMixin);
/**
 * HTML
 */

var HTML = function HTML(_ref) {
  var html = _ref.html,
      rest = _objectWithoutProperties(_ref, ["html"]);

  return _react.default.createElement(Container, _extends({
    dangerouslySetInnerHTML: {
      __html: html
    }
  }, rest));
};

exports.HTML = HTML;
HTML.displayName = "HTML";
HTML.displayName = "HTML";
//# sourceMappingURL=HTML.js.map